require( './contact-form-mask.js' );
require( './contact-form-placeholder.js' );
require( './defer-cf7-scripts.js' );
require( './contact-form-result.js' );
